import { render, staticRenderFns } from "./infoResidente.vue?vue&type=template&id=366c20d5&scoped=true"
import script from "./infoResidente.vue?vue&type=script&lang=js"
export * from "./infoResidente.vue?vue&type=script&lang=js"
import style0 from "./infoResidente.vue?vue&type=style&index=0&id=366c20d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c20d5",
  null
  
)

export default component.exports